@if (this.loader) {
  <ngx-ui-loader
    [appLoader]="this.apiCall.isLoading$"
    [appLoaderId]="this.loaderId"
    [loaderId]="this.loaderId"
    [fgsColor]="'var(--loader-spinner-color)'"
    [overlayColor]="'var(--loader-bg)'"
    [pbThickness]="0"
  ></ngx-ui-loader>
}

@if (this.showError$ | async) {
  <div class="text-center">
    {{ errorMessage | translate }}
    {{ this.apiCall.error$ | async | json }}
  </div>
}

@if (this.showEmptyContent$ | async) {
  <div class="text-center">
    {{ emptyMessage | translate }}
  </div>
}

@if (this.showContent$ | async) {
  <ng-content></ng-content>
}
<!--<ng-content *ngIf="true"></ng-content>-->
